import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { DrawerPane } from 'owa-drawer';
import {
    ChatCopilotPane as LazyChatCopilotBody,
    ChatCopilotPaneHeader as LazyChatCopilotPaneHeader,
} from 'owa-copilot-chat';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import { observer } from 'owa-mobx-react';
import { isFlexPaneExpanded } from 'owa-suite-header-store';
import {
    copilotChatContainer,
    copilotChatContainerExpanded,
    copilotChatHeader,
    copilotChatBody,
} from '../AppPaneGroup.scss';
import isFlexPaneShownHelper from 'owa-app-pane-group-utils/lib/helpers/isFlexPaneShownHelper';

const chatCopilotPaneTitle = () => {
    return <LazyChatCopilotPaneHeader />;
};

const defaultExport: React.FunctionComponent = observer(function ChatCopilotPane() {
    const paneId = getDrawerPaneId('chatCopilot');

    return (
        <DrawerPane
            className={
                isFlexPaneExpanded(paneId) ? copilotChatContainerExpanded : copilotChatContainer
            }
            paneId={paneId}
            headerText={chatCopilotPaneTitle()}
            headerClassName={copilotChatHeader}
            bodyClassName={copilotChatBody}
            preload={isFeatureEnabled('fwk-copilot-iframe-preload')}
            role={'complementary'}
        >
            <LazyChatCopilotBody isVisible={isFlexPaneShownHelper('ChatCopilot', 'chatCopilot')} />
        </DrawerPane>
    );
}, 'ChatCopilotPane');
export default defaultExport;
